var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70312 17.3037C5.56099 17.3037 2.20312 13.9458 2.20312 9.80371C2.20312 5.66157 5.56099 2.30371 9.70312 2.30371C13.8452 2.30371 17.2031 5.66157 17.2031 9.80371C17.2031 13.9458 13.8452 17.3037 9.70312 17.3037ZM8.95312 12.0537V13.5537H10.4531V12.0537H8.95312ZM8.95312 6.05371V10.5537H10.4531V6.05371H8.95312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/ReportIcon.289b773df7a13335b558a7990a5b8b55.svg";
export { ForwardRef as ReactComponent };